// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
//
Vue.use(VueI18n)

Vue.config.productionTip = false

const messages = {
  en: {
    message: {
      test: 'hello world'
    }
  }
}

const i18n = new VueI18n({
  locale: 'en',
  messages
})

// Create a Vue instance with `i18n` option
// new Vue({ i18n }).$mount('#app')

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js